import { BaseEntityService } from '@/modules/core/app/services/abstracts/BaseEntityService';
import { HubSpotProduct } from '@/modules/hubspot/models/HubSpotProduct';
import { Route } from '@/modules/core/app/constants/api.constants';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { getters } from '/@/modules/core/app/helpers/store';

export class HubSpotProductService extends BaseEntityService<HubSpotProduct> {
  getModel(): typeof HubSpotProduct {
    return HubSpotProduct;
  }

  getRoute(): string {
    return Route.HUBSPOT_PRODUCTS;
  }

  async getProductsWithKeys(
    productKeys: ProductKey[],
    forJurisdiction?: number
  ): Promise<HubSpotProduct[]> {
    return await this.getEntities({
      forJurisdiction: forJurisdiction ?? getters.auth.getCurrentEstate()?.jurisdictionId,
      propertyProductkey: productKeys
    });
  }
}

export default new HubSpotProductService();
